<template>
  <div class="contact">
    <!-- Hero 大图区 -->
    <section class="contact-hero">
      <div class="contact-hero-bg">
        <img src="/static/lx.png" alt="联系我们">
      </div>
      <!-- <div class="contact-hero-content">
        <div class="contact-hero-title">
          <div class="hero-bar"></div>
          <h1>{{ activeTab === 'recruit' ? '招贤纳士' : '联系我们' }}</h1>
          <p class="contact-hero-en">{{ activeTab === 'recruit' ? 'NEWS CENTER' : 'CONTACT US' }}</p>
        </div>
      </div> -->
    </section>

    <!-- Tab 切换 -->
    <section class="contact-tab-section">
      <div class="container">
        <div class="contact-tabs">
          <div
            class="contact-tab-item"
            :class="{ active: activeTab === 'contact' }"
            @click="activeTab = 'contact'"
          >
            联系方式
          </div>
          <div class="contact-tab-divider"></div>
          <div
            class="contact-tab-item"
            :class="{ active: activeTab === 'recruit' }"
            @click="activeTab = 'recruit'"
          >
            招贤纳士
          </div>
        </div>
      </div>
    </section>

    <!-- 联系方式 -->
    <section v-if="activeTab === 'contact'" class="contact-main-section">
      <div class="container">
        <div class="company-name">新恒丰咨询集团有限公司</div>
        <div class="company-line"></div>

        <!-- 电话/地址/邮箱 三列信息 -->
        <div class="company-info-row" data-aos="fade-up">
          <div class="company-info-item">
            <h4>电话：</h4>
            <p>0371-56972228</p>
          </div>
          <div class="company-info-item">
            <h4>地址：</h4>
            <p>河南省郑州市金水区杨金路139号C7号楼</p>
          </div>
          <div class="company-info-item">
            <h4>邮箱：</h4>
            <p>xhfzxt@126.com</p>
          </div>
        </div>

        <!-- 地图 -->
        <div class="contact-map" data-aos="fade-up">
          <div class="map-placeholder">
            <div class="map-pin">
              <i class="el-icon-map-location"></i>
            </div>
            <div class="map-info-window">
              <h5>新恒丰咨询集团有限公司</h5>
              <p>地址：河南省郑州市金水区杨金路139号C7号楼</p>
              <p>电话：0371-56972228</p>
            </div>
          </div>
        </div>

        <!-- 在线留言 -->
        <div class="contact-form-wrap" data-aos="fade-up">
          <div class="form-section-title">
            <span class="title-bar"></span>
            <h3>在线留言</h3>
          </div>
          <div class="form-card">
            <div class="form-intro">
              请填写您的留言，我们会尽快回复~
            </div>
            <el-form :model="form" :rules="rules" ref="formRef" label-position="top">
              <div class="form-row">
                <el-form-item label="请填写您的姓名" prop="name">
                  <el-input v-model="form.name" placeholder="请填写您的姓名"></el-input>
                </el-form-item>
                <el-form-item label="请填写您的手机号" prop="phone">
                  <el-input v-model="form.phone" placeholder="请填写您的手机号"></el-input>
                </el-form-item>
              </div>
              <div class="form-row">
                <el-form-item label="请填写邮箱地址" prop="email">
                  <el-input v-model="form.email" placeholder="请填写邮箱地址"></el-input>
                </el-form-item>
                <el-form-item label="请填写公司名称" prop="company">
                  <el-input v-model="form.company" placeholder="请填写公司名称"></el-input>
                </el-form-item>
              </div>
              <el-form-item label="请填写留言信息" prop="message">
                <el-input
                  type="textarea"
                  v-model="form.message"
                  placeholder="请填写留言信息"
                  :rows="4"
                ></el-input>
              </el-form-item>
              <div class="form-submit-row">
                <button type="button" class="btn-submit" @click="submitForm">提交留言</button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </section>

    <!-- 招贤纳士 -->
    <section v-if="activeTab === 'recruit'" class="recruit-main-section">
      <div class="container">
        <div class="recruit-grid">
          <div
            v-for="(job, index) in pagedJobs"
            :key="job.id"
            class="job-card"
            data-aos="fade-up"
            :data-aos-delay="(index % 6) * 80"
            @click="goDetail(job.id)"
          >
            <div class="job-card-header">
              <h3 class="job-title">{{ job.title }}</h3>
              <div class="job-location">
                <i class="el-icon-map-location"></i>
                {{ job.location }}
              </div>
            </div>
            <div class="job-card-desc">
              性别：不限/年龄：不限/{{ job.education }}/招聘人数：{{ job.count }}人
            </div>
            <div class="job-card-date">
              <i class="el-icon-time"></i>
              {{ job.date }}
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="recruit-pagination">
          <span class="page-info">共{{ totalJobs }}条</span>
          <button
            class="page-btn"
            :disabled="currentPage === 1"
            @click="currentPage--"
          >上一页</button>
          <button
            v-for="p in totalPages"
            :key="p"
            class="page-num"
            :class="{ active: currentPage === p }"
            @click="currentPage = p"
          >{{ p }}</button>
          <button
            class="page-btn"
            :disabled="currentPage === totalPages"
            @click="currentPage++"
          >下一页</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      activeTab: 'contact',
      // 表单
      form: {
        name: '',
        phone: '',
        email: '',
        company: '',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        message: [
          { required: true, message: '请输入留言内容', trigger: 'blur' }
        ]
      },
      // 招聘数据
      currentPage: 1,
      pageSize: 10,
      jobs: [
        { id: 1, title: '市场开发部经理', location: '深圳', education: '本科', count: 2, date: '2036年5月26日' },
        { id: 2, title: '人力资源部经理', location: '深圳', education: '本科', count: 2, date: '2036年5月26日' },
        { id: 3, title: '标书制作专员', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日' },
        { id: 4, title: '监理员', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日' },
        { id: 5, title: '住建部注册监理工程师', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日' },
        { id: 6, title: '水利部注册监理工程师', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日' },
        { id: 7, title: '交通部注册监理工程师', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日' },
        { id: 8, title: '注册造价工程师（安装专业）', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日' },
        { id: 9, title: '注册造价工程师（水利专业）', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日' },
        { id: 10, title: '注册造价工程师（公路运输专业）', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日' },
        { id: 11, title: '注册安全工程师', location: '深圳', education: '不限/大专', count: 2, date: '2036年5月26日' },
        { id: 12, title: '注册一级结构工程师', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日' },
        { id: 13, title: '高级工程师', location: '郑州', education: '本科', count: 3, date: '2036年5月26日' },
        { id: 14, title: '注册咨询工程师（投资）', location: '郑州', education: '本科', count: 2, date: '2036年5月26日' },
        { id: 15, title: '项目经理', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日' }
      ]
    }
  },
  computed: {
    totalJobs() {
      return this.jobs.length
    },
    totalPages() {
      return Math.ceil(this.totalJobs / this.pageSize)
    },
    pagedJobs() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.jobs.slice(start, start + this.pageSize)
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push(`/recruit/detail/${id}`)
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$message.success('留言提交成功，我们将尽快与您联系！')
          this.resetForm()
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    resetForm() {
      this.$refs.formRef.resetFields()
    }
  },
  watch: {
    activeTab() {
      this.currentPage = 1
    }
  }
}
</script>

<style lang="scss" scoped>
/* ===== Hero ===== */
.contact-hero {
  position: relative;
  height: 320px;
  overflow: hidden;
}

.contact-hero-bg {
  position: absolute;
  inset: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.contact-hero-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
}

.contact-hero-title {
  color: #fff;
  padding-left: 120px;
}

.hero-bar {
  width: 60px;
  height: 4px;
  background: #c8102e;
  margin-bottom: 24px;
}

.contact-hero-title h1 {
  font-size: 44px;
  font-weight: 700;
  margin: 0 0 12px;
  letter-spacing: 2px;
}

.contact-hero-en {
  font-size: 16px;
  letter-spacing: 4px;
  opacity: 0.85;
  margin: 0;
}

/* ===== Tab 切换 ===== */
.contact-tab-section {
  background: #fff;
  border-bottom: 1px solid #eee;
}

.contact-tabs {
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 18px 0;
  max-width: 1200px;
  margin: 0 auto;
}

.contact-tab-item {
  font-size: 15px;
  color: #333;
  cursor: pointer;
  padding: 6px 0;
  position: relative;
  transition: color 0.25s;
  user-select: none;

  &:hover {
    color: #c8102e;
  }

  &.active {
    color: #c8102e;
    font-weight: 600;
  }

  &.active::after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 0;
    width: 100%;
    height: 2px;
    background: #c8102e;
  }
}

.contact-tab-divider {
  width: 1px;
  height: 14px;
  background: #ddd;
}

/* ===== 通用容器 ===== */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ===== 联系方式 ===== */
.contact-main-section {
  padding: 60px 0 80px;
  background: #fff;
}

.company-name {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: #222;
  padding-top: 10px;
  margin-bottom: 18px;
}

.company-line {
  width: 60px;
  height: 3px;
  background: #c8102e;
  margin: 0 auto 50px;
}

.company-info-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border: 1px solid #eee;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 30px;
}

.company-info-item {
  padding: 30px 20px;
  text-align: center;
  border-right: 1px solid #eee;

  &:last-child {
    border-right: none;
  }

  h4 {
    font-size: 15px;
    color: #222;
    margin: 0 0 10px;
  }

  p {
    font-size: 14px;
    color: #666;
    margin: 0;
    line-height: 1.6;
  }
}

/* 地图 */
.contact-map {
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 60px;
  border: 1px solid #eee;
}

.map-placeholder {
  position: relative;
  height: 340px;
  background: linear-gradient(135deg, #eaf3ff 0%, #d7e8ff 50%, #c6ddff 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.map-pin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
  font-size: 36px;
  color: #c8102e;
  z-index: 2;

  i {
    font-size: 36px;
  }
}

.map-info-window {
  position: absolute;
  top: calc(50% - 120px);
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 14px 20px;
  border-radius: 4px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  min-width: 280px;
  z-index: 3;

  h5 {
    font-size: 14px;
    margin: 0 0 8px;
    color: #222;
  }

  p {
    font-size: 12px;
    color: #666;
    margin: 2px 0;
  }
}

/* 表单 */
.contact-form-wrap {
  max-width: 100%;
}

.form-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;

  .title-bar {
    width: 4px;
    height: 22px;
    background: #c8102e;
    border-radius: 2px;
  }

  h3 {
    font-size: 22px;
    font-weight: 600;
    color: #222;
    margin: 0;
  }
}

.form-card {
  background: #f5f5f5;
  padding: 40px;
  border-radius: 6px;
}

.form-intro {
  font-size: 15px;
  color: #555;
  margin-bottom: 28px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

::v-deep .el-form-item {
  margin-bottom: 22px;
}

::v-deep .el-form-item__label {
  font-size: 13px;
  color: #666;
  padding-bottom: 6px;
}

::v-deep .el-form-item.is-required > .el-form-item__label::before {
  content: '*';
  color: #c8102e;
}

::v-deep .el-input__inner {
  background: #fff;
  border-color: #ddd;
}

::v-deep .el-textarea__inner {
  background: #fff;
  border-color: #ddd;
}

.form-submit-row {
  margin-top: 10px;
}

.btn-submit {
  background: #c8102e;
  color: #fff;
  border: none;
  padding: 10px 40px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 2px;
  transition: background 0.25s;

  &:hover {
    background: #a50d26;
  }
}

/* ===== 招贤纳士 ===== */
.recruit-main-section {
  padding: 60px 0 80px;
  background: #fff;
}

.recruit-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 50px;
}

.job-card {
  background: #f6f6f6;
  padding: 28px 30px;
  border-radius: 4px;
  cursor: pointer;
  transition: box-shadow 0.25s, transform 0.25s, background 0.25s;

  &:hover {
    background: #fff;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
}

.job-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.job-title {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin: 0;
}

.job-location {
  font-size: 14px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 4px;

  i {
    color: #888;
  }
}

.job-card-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 12px;
}

.job-card-date {
  font-size: 13px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 4px;

  i {
    font-size: 14px;
  }
}

/* 分页 */
.recruit-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 20px;

  .page-info {
    font-size: 14px;
    color: #666;
    margin-right: 12px;
  }

  .page-btn,
  .page-num {
    min-width: 36px;
    height: 36px;
    padding: 0 12px;
    border: 1px solid #ddd;
    background: #fff;
    color: #333;
    font-size: 14px;
    cursor: pointer;
    border-radius: 2px;
    transition: all 0.2s;

    &:hover:not(:disabled) {
      border-color: #c8102e;
      color: #c8102e;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  .page-num.active {
    background: #c8102e;
    border-color: #c8102e;
    color: #fff;
  }
}

/* ===== 响应式 ===== */
@media (max-width: 992px) {
  .company-info-row {
    grid-template-columns: 1fr;
  }

  .company-info-item {
    border-right: none;
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none;
    }
  }

  .recruit-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
}

@media (max-width: 768px) {
  .contact-hero {
    height: 240px;
  }

  .contact-hero-title {
    padding-left: 40px;
  }

  .contact-hero-title h1 {
    font-size: 32px;
  }

  .contact-hero-en {
    font-size: 14px;
  }

  .contact-tabs {
    gap: 24px;
    padding: 14px 0;
  }

  .contact-main-section,
  .recruit-main-section {
    padding: 40px 0 60px;
  }

  .company-name {
    font-size: 18px;
    margin-bottom: 14px;
  }

  .company-line {
    margin-bottom: 30px;
  }

  .map-placeholder {
    height: 260px;
  }

  .map-info-window {
    min-width: 220px;
    top: calc(50% - 110px);
    padding: 10px 14px;

    h5 {
      font-size: 13px;
    }
  }

  .form-card {
    padding: 24px 20px;
  }

  .job-card {
    padding: 22px 20px;
  }

  .job-title {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .contact-hero {
    height: 200px;
  }

  .contact-hero-title {
    padding-left: 20px;
  }

  .contact-hero-title h1 {
    font-size: 26px;
  }

  .contact-hero-en {
    font-size: 12px;
    letter-spacing: 2px;
  }

  .contact-tabs {
    gap: 20px;
  }

  .contact-tab-item {
    font-size: 14px;
  }

  .recruit-pagination {
    flex-wrap: wrap;
  }
}
</style>
